import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const CourseFeedbackDetails = lazyRouteComponent(() => import('@/_instructor/course-feedback/details'));

export const Route = createFileRoute('/_instructor/course-feedback-details')({
  component: () => renderInstructorPage(CourseFeedbackDetails),
});
